<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>

    <div v-else>
      <vx-card>
        <vs-table
          :max-items="descriptionItems[0]"
          pagination
          :data="priorityMappings"
          description
          search
          @selected="openView"
          :description-items="descriptionItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
        >
          <template slot="header">
            <div class="list-heading">
              {{ $t("setup.label.SubCategory") }}
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-plus"
                @click="$router.push({ name: 'Create Sub Category' })"
                size="small"
                >{{ $t("setup.label.CreateSubCategory") }}</vs-button
              >
            </div>
          </template>
          <template slot="thead">
            <vs-th>{{ $t("setup.label.MainCategory") }}</vs-th>
            <vs-th>{{ $t("setup.label.SubCategory") }}</vs-th>
            <vs-th>{{ $t("setup.label.Priority") }}</vs-th>
            <vs-th class="tHeadCenter">{{ $t("setup.label.Action") }}</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr
              :key="index"
              :data="priorityMapping"
              v-for="(priorityMapping, index) in data"
            >
              <vs-td :data="priorityMapping.mainCategory">{{
                priorityMapping.mainCategory
              }}</vs-td>
              <vs-td :data="priorityMapping.subCategory">{{
                priorityMapping.subCategory
              }}</vs-td>
              <vs-td :data="priorityMapping.priority">{{
                priorityMapping.priority
              }}</vs-td>
              <vs-td class="whitespace-no-wrap">
                <div class="container_img">
                  <feather-icon
                    icon="EyeIcon"
                    :title="$t('setup.label.View')"
                    svgClasses="w-5 h-5 stroke-current cursor text-primary"
                    @click.stop="openView(priorityMapping)"
                    class="icon_row"
                  />
                  <feather-icon
                    icon="EditIcon"
                    :title="$t('setup.label.Edit')"
                    svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                    @click.stop="editData(priorityMapping.id)"
                    class="icon_row"
                  />
                  <feather-icon
                    icon="TrashIcon"
                    :title="$t('setup.label.Delete')"
                    svgClasses="w-5 h-5 text-danger stroke-current cursor"
                    @click.stop="
                      deleteItemPopup = true;
                      delId = priorityMapping.id;
                    "
                    class="icon_row"
                  />
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('setup.label.DeletePriorityMapping')"
          :active.sync="deleteItemPopup"
          class="popup-close small-popup"
        >
          <div class="center">
            <img src="@/assets/images/pages/delete.svg" />
            <div class="success-msg">
              {{ $t("system.label.areYouSureDelete") }}
            </div>
          </div>

          <div class="center">
            <span class="p-2">
              <vs-button type="border" @click="deleteItemPopup = false">{{
                $t("system.label.cancel")
              }}</vs-button></span
            >

            <span class="p-2">
              <vs-button @click="removePriorityMapping(delId)">{{
                $t("setup.label.Ok")
              }}</vs-button>
            </span>
          </div>
          <div style="height: 20px"></div>
        </vs-popup>
      </div>
    </div>
  </div>
</template>

<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: false,
      descriptionItems: [5, 10, 15],
      deleteItemPopup: false,
    };
  },
  components: { AtomSpinner },
  computed: {
    ...mapState({
      priorityMappings: (state) => state.priorityMapping.priorityMappings,
    }),
  },
  methods: {
    async getMappingList() {
      this.loading = true;
      try {
        await this.$store.dispatch("priorityMapping/fetchPriorityMappingList");
      } catch (e) {
        this.$toasted.error(e.message);
      }
      this.loading = false;
    },
    editData(id) {
      this.$router.push({ name: "Edit Sub Category", params: { id: id } });
    },
    openView(priorityMappings) {
      this.$router.push({
        name: "View Sub Category",
        params: { id: priorityMappings.id },
      });
    },
    async removePriorityMapping(id) {
      try {
        await this.$store.dispatch(
          "priorityMapping/deletePriorityMappingAction",
          id
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Priority Mapping Successfully Deleted",
          type: "success",
        });
        this.deleteItemPopup = false;
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
  },
  mounted() {
    this.getMappingList();
  },
};
</script>

<style lang="scss"></style>
